module.exports = __webpack_public_path__ + "img/payment-success.864797cb.webp";